import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import NewArrivals from "./NewArrivals";

export default function NewArrivalsSwiper() {
  const [newArrivals, setNewArrivals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL

  // Fetch new arrivals from the API
  useEffect(() => {
    const fetchNewArrivals = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/new-arrival`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setNewArrivals(data.new_arrivals);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching new arrivals:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNewArrivals();
  }, []);

  if (loading) {
    return (
      <div className="w-full h-96 flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-[#D4AF37]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full h-96 flex items-center justify-center bg-gray-100">
        <p className="text-red-500 text-lg">Error: {error}</p>
      </div>
    );
  }

  if (!newArrivals.length) {
    return (
      <div className="w-full h-96 flex items-center justify-center bg-gray-100">
        <p className="text-gray-600 text-lg">No new arrivals found</p>
      </div>
    );
  }

  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={20}
      slidesPerView={1}
      autoplay={{ delay: 3000 }}
      breakpoints={{
        640: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
      className="py-4"
    >
      {newArrivals.map((product, index) => (
        <SwiperSlide key={index}>
          <NewArrivals product={product} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
